<template>
	<div>
		<joy-page :joyPageStatus="joyPageStatus">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" finished-text="加载完毕" @load="onLoad">
					<div class="paddingbottom50 ">
						<van-panel  class="marginBottomXm" v-for="(item,index) in list"  :key="index" >
						  <div slot="default" class="paddingXm text-black text-xl"  @click="editComment(item.id,item.content)">{{item.content}}</div>
						  <div slot="footer">
						    <van-tag  round  type="warning" class="marginRightXm">{{item.created_at}}</van-tag>
						    <van-button @click="delteComment(item.id,index)" round size="mini" type="danger">删除</van-button>
						  </div>
						</van-panel>
						<div class="fixBottom">
							<van-button  @click="goAddComment()" type="info" size="large">新增评论</van-button>
						</div>
					</div>
					<van-action-sheet v-model="showCommont" :title="dialogType"  round lock-scroll>
					  <div class="paddingXm">
						  <van-field
						     v-model="commontWord"
							  rows="3"
							  autosize
						      clearable
						      label="评论"
						      placeholder="请输入标题"
						    />
					  </div>
						<van-button size="large"   @click="commit" type="primary">保存</van-button>
					</van-action-sheet>
				</van-list>
			</van-pull-refresh>
		</joy-page>
	</div>
</template>

<script>
	
	export default {
		created() {
			this.onLoad();
		},
		data() {
			return {
				showCommont:false,
				commontWord:'',
				dialogType:"",
				joyPageStatus: '',
				list:'',
				loading: false,
				finished: false,
				isLoading: false,
				editId:'',
			};
		},
		watch:{
			showCommont:function(val){
				if(!val){
					this.dialogType='';
					this.commontWord="";
					this.editId="";
				}
			}
		},
		methods: {
			editComment(id,content){
				this.editId=id;
				this.commontWord=content;
				this.dialogType='修改评论';
				this.showCommont=true;
			},
			commit(){
				const that =this;
				if(that.commontWord=='' && that.commontWord==null){
					that.$toast('内容不得为空')
				}else{
					let query={
						children_id :that.children_id,
						camp_id:that.camp_id,
						content:that.commontWord
					};
					let query2={
						comment_id :that.editId,
						content:that.commontWord
					};
					if(this.dialogType=='新增评论'){
						try{
							this.$axios.post('comment/create',query).then(res => {
								if(res.data.code==200){
									let add={
										id:res.data.data.id,
										content:that.commontWord,
										created_at:res.data.data.created_at
									};
									that.list.unshift(add);
									this.$toast('新增成功');
									this.showCommont=false;
								}else{
									this.$toast.fail(res.data.msg)
								}
							})
						}catch(e){
							if (this.$mConfig.debug) {
								console.log(e);
							};
						}
						
					}else if(this.dialogType=='修改评论'){
						try{
							this.$axios.put('comment/update',query2).then(res => {
								if(res.data.code==200){
									for (let i in that.list) {
										if(that.list[i].id==that.editId){
											that.list[i].content=that.commontWord;
										}
									}
									this.$toast('修改成功');
									this.showCommont=false;
								}else{
									this.$toast.fail(res.data.msg)
								}
							})
						}catch(e){
							if (this.$mConfig.debug) {
								console.log(e);
							};
						}
					}
				}
				
			},
			goAddComment(){
				this.showCommont=true;
				this.dialogType="新增评论";
			},
			onRefresh() {
				  setTimeout(() => {
					
					this.isLoading = false;
					this.reload();
					this.$toast('刷新成功');
				  }, 500);
			},
			onLoad() {
				// 异步更新数据
				setTimeout(() => {
					this.loadData();
				}, 500);
			},
			reload() {
				this.list = [];
				this.loading = false;
				this.finished = false;
				this.onLoad();
			},
			delteComment(id,index){
				try{
					this.$axios.delete('comment/delete?comment_id='+id).then(res => {
						if(res.data.code==200){
							this.list.splice(index,1);
							this.$toast.success('删除成功');
						}else{
							this.$toast.fail(res.data.msg)
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
			loadData(){
				this.children_id= this.$route.query.children_id;
				this.camp_id=this.$route.query.camp_id;
				const that=this;
				this.joyPageStatus = 'loading';
				try{
					this.$axios.get('comment/list?children_id='+this.children_id).then(res => {
						this.joyPageStatus = 'success';
						if(res.data.code==200){
							this.list=res.data.data;
							this.loading = false;
							this.finished = true;
						}else{
							this.$toast.fail(res.data.msg)
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		}
	};
</script>

<style>
</style>
